import React from 'react';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/table/Table';
import { columns } from './columns';
import './NoticeProductItemListModal.scss';

const NoticeProductItemListModal = (props) => {
  const { isOpen, closeModal, getNoticeProductItemList, data } = props;
  const { list, pagination } = data.listData;

  return (
    <Modal
      title="상품 공지사항에 등록된 상품"
      isOpen={isOpen}
      width={1500}
      height={600}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="notice-product-item-list-modal">
        <Table
          className="notice-product-item-list-table"
          emptyText="상품 공지사항에 등록된 상품 목록이 없습니다."
          data={list}
          pagination={pagination}
          getList={getNoticeProductItemList}
          showPagination
          columns={(utils) =>
            columns({
              pageNum: pagination.pageNum,
              ...utils,
            })
          }
        />
      </div>
    </Modal>
  );
};

export default NoticeProductItemListModal;
